import { useTheme } from '../../theme/ThemeContext';
export const useTextStyles = ({
  size,
  weight,
  color
}) => {
  const theme = useTheme();
  const COLOR_MAP = {
    default: theme.colors.text,
    secondary: theme.colors.textSecondary,
    accent: theme.colors.primary,
    muted: theme.colors.textMuted,
    danger: theme.colors.danger
  };
  const SIZE_MAP = {
    sm: theme.fontSizes.sm,
    md: theme.fontSizes.md,
    lg: theme.fontSizes.lg,
    xl: theme.fontSizes.xl
  };
  const WEIGHT_MAP = {
    normal: theme.fontWeights.normal,
    bold: theme.fontWeights.bold
  };
  return {
    fontSize: size ? SIZE_MAP[size] : undefined,
    fontWeight: weight ? WEIGHT_MAP[weight] : undefined,
    color: color ? COLOR_MAP[color] : undefined
  };
};